import { SubProductState } from './user';

export interface FilterOption {
  id: string;
  label: string;
  labelDescription?: string;
  isSelected: boolean;
  lockState?: SubProductState;
  isDefault?: boolean;
}

export enum FilterType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

export interface SearchFilter {
  type: FilterType;
  name: string;
  options: FilterOption[];
}

export interface SearchFilters {
  subProducts: SearchFilter;
}
